import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

import Referrals from '../rewards/referrals';
import { SettingsCache } from '~/lib/consts/settings-cache';
import Rewards from '../rewards/rewards';

export const childrenOfRewards = [
  {
    path: RoutingConstants.Referrals,
    element: <Referrals />
  },
  {
    path: RoutingConstants.Rewards,
    element: <Rewards />
  }
];

export const routesOfRewards = childrenOfRewards.map((r) => r.path);

export const sanitisedRoutesOfRewards = () =>
  routesOfRewards.filter((x) => {
    switch (x) {
      case RoutingConstants.Referrals:
        return SettingsCache.settings.Features.includes('Referrals');

      case RoutingConstants.Rewards:
        return SettingsCache.settings.Features.includes('Rewards');

      default:
        return true;
    }
  });
